import React, { Fragment } from "react";
import { useEffect, useState } from "react";
import { setGoHome, setLoader } from "../../action/homeAction";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
 import { CMSPath } from "../../../config/constant";
import { sendAnalytics } from "../../../action/homeAction";
import { closeOrderPopUp } from "../../action/hCommerce2";
import moment from "moment";
import { scrollToTop } from "../../../JS/scrollToTop";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import { popupOpenClose } from "../../../action/action";
import { DayPicker } from "react-day-picker";


function Event4_PreferredAvailability(props) {
    const { t } = props;
    const [renderDateInput, setRenderDateInput] = useState(false);
    


    let dateInputCss = `
    .rdp-day_selected {
        color: ${props.menuColor.assetFontSelectorColor};
        background-color: ${props.menuColor.assetBackgroundSelectorColor};
    }`;
    let acceptedDates;

    const isDayDisabled=(date)=>{
        if(!acceptedDates){

            const venueId=props.selectedVenue.venueId;
            const event_= props.selectedEvent.events.find(event=>event.venueId==venueId)  ;
            acceptedDates= event_.applicable_dates


            // acceptedDates= props.selectedEventAndInventory.differentVenues.find(e=>e.venueId==props.selectedVenue.venueId).applicable_dates;
            console.log(acceptedDates);
        }

        const serverDate=new Date(props.serverTimeDate.split("T")[0]);
        
        const isDateAccepted =()=>{
            console.log(moment(date).format("MM/DD/YYYY"))
            if( acceptedDates.includes(moment(date).format("MM/DD/YYYY"))){
                return true;
            }
            return false;
        } ;



        return !isDateAccepted() || serverDate > new Date(date)
         }



    const handleNext = () => {

        // if(!props.selectedInventory){
        //     props.popupOpenClose(true, t("events.select_inventory"));
        //     return;
        // }
        if (props.preferredDateTime.date == "") {
            props.popupOpenClose(true, t("events.select_preferred_date"));
            return;
        }

        if (isNaN(Number(props.preferredDateTime.guestCount)) || Number(props.preferredDateTime.guestCount) < 1) {
            props.popupOpenClose(true, t("events.fill_valid_guestCount"));
            return;
        }



        try {
            
            props.next();
        } catch (err) {
            props.closeOrderPopUp(true, err, "", true);

        }

    }


    


    useEffect(() => {
        scrollToTop();     
        
    }, [])

    return (
        <Fragment>
            <header className="inner-pages w-footer subpages">
                <a className="button-back" onClick={props.back}></a>
                <div className="heading align-center">
                    <div class="splash-brand">
                        <img src={`${CMSPath}${props.logo}`} />
                    </div>
                </div>
            </header>
            <section class="widgets spa-listing spa-details">
                <div class="widget-header">
                    {props.currentWidgetObj.widgetHeaderImageUrl && (
                        <div class="widget-header-img">
                            <img
                                src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                                alt={props.currentWidgetObj.displayName}
                            />
                        </div>
                    )}
                    <div class="widget-header-title">{t(`events.heading4`)}</div>
                    {/* <div class="widget-header-subtitle">
                        {props.selectedService.service.description ||
                            props.selectedService.service.extendedDescription}
                    </div> */}
                </div>








                <div class="row" style={{ marginBottom: '4px' }}>
                    <div class="col">
                        <div class="detail-body stay-body">
                            <form>
                                <div class="form-row">


                                    <p class="heading">{t("events.guestCount")}<span style={{ color: "red" }}>*</span></p>

                                    <div class="qty-input">

                                        <input type="text" value={props.preferredDateTime.guestCount} onChange={(event) => { console.log(event.target.value); props.setPreferredDateTime({ ...props.preferredDateTime, guestCount: event.target.value }) }} />
                                        <button disabled={isNaN(Number(props.preferredDateTime.guestCount))} onClick={(e) => {
                                            e.preventDefault();
                                            props.setPreferredDateTime({ ...props.preferredDateTime, guestCount: String(Number(props.preferredDateTime.guestCount) + 1) })
                                        }}>+</button>
                                        <button disabled={isNaN(Number(props.preferredDateTime.guestCount)) || Number(props.preferredDateTime.guestCount) <= 1} onClick={(e) => {
                                            e.preventDefault();
                                            props.setPreferredDateTime({ ...props.preferredDateTime, guestCount: String(Number(props.preferredDateTime.guestCount) - 1) })
                                        }}>-</button>

                                    </div>


                                </div>




                                <div class="form-row">
                                    <p class="heading">
                                        {t("events.preferred_date")}{" "}
                                        <span style={{ color: "red" }}>*</span>
                                    </p>
                                    <input
                                        type="button"
                                        value={
                                            props.preferredDateTime.date == ''
                                                ?
                                                t("events.select_date_placeholder")
                                                :
                                                moment(props.preferredDateTime.date).format((props.dateFormat).toUpperCase())
                                        }
                                        onClick={() => setRenderDateInput(!renderDateInput)}
                                    />

                                    {/* date formatting remains */}
                                </div>


                            </form>
                        </div>
                    </div>
                </div >

                <div class="row">
                    <div class="form-controls">
                        <button onClick={handleNext}>{t("events.next")}</button>
                        <button onClick={props.back}>{t('events.back')}</button>
                    </div>
                </div>

                {
                    renderDateInput && (
                        <div
                            className="overlay"
                            onClick={() => setRenderDateInput(!renderDateInput)}
                        >
                            <div
                                onClick={(event) => {
                                    event.stopPropagation();
                                }}
                                class="overlay-date"
                            >
                                <style>{dateInputCss}</style>
                                <DayPicker
                                    mode="single"
                                    selected={props.preferredDateTime.date == '' ? undefined : new Date(props.preferredDateTime.date)}
                                    onSelect={(selectedDate) => { console.log(selectedDate); props.setPreferredDateTime({ ...props.preferredDateTime, date: selectedDate?new Date(selectedDate):'' }); setRenderDateInput(!renderDateInput) }
                                    }
                                    // disabled={
                                    //     {
                                    //         before: new Date(props.serverTimeDate.split("T")[0])
                                    //     }
                                           
                                    // }
                                    disabled={isDayDisabled}
                                    
                                    
                                />
                            </div>
                        </div>
                    )
                }
            </section >
        </Fragment >
    )
}
const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        serverTimeDate: state.store.home.serverTimeDate.date,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
        menuColor: state.store.home.MenuColor,
        currencyCode: state.store.home.clientConfig.currencyDetails
            ? state.store.home.clientConfig.currencyDetails.code
            : ""

    }
}

const mapDispatchToProps = { setGoHome, closeOrderPopUp, sendAnalytics, popupOpenClose }

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('translations')(Event4_PreferredAvailability));

